import styled from 'styled-components';

export const Container = styled.div`
  height: 250px;
  width: 100%;
  position: relative;
  margin-bottom: 40px;
  background: var(--white-darker);
  border-radius: 8px;

  input {
    display: none;
  }

  > label {
    height: 50px;
    width: calc(100% - 20px);
    border-radius: 8px;
    padding: 20px;
    display: flex;
    align-items: center;
    background: var(--black-transparent);
    cursor: pointer;
    position: absolute;
    bottom: 10px;
    left: 10px;
    color: var(--white);
    font-weight: bold;

    outline: none;
    transition: box-shadow 0.2s ease-in-out;
  }
`;

export const Items = styled.div`
  height: 100%;
  width: 100%;
  overflow: hidden;
  display: flex;
  border-radius: 8px;

  > div {
    flex: none;
    height: 100%;
    width: 100%;
    position: relative;
    border-radius: 8px;
    transition: 0.5s ease-in-out;

    > button {
      height: 30px;
      width: 30px;
      border-radius: 50%;
      color: var(--white);
      background: var(--black-transparent);
      border: 0;
      cursor: pointer;

      display: flex;
      justify-content: center;
      align-items: center;

      position: absolute;
      top: 20px;
      right: 20px;
      z-index: 2;
    }
  }
`;

export const Image = styled.img`
  flex: none;
  height: 100%;
  width: 100%;
  object-fit: cover;
  transition: 0.5s ease-in-out;
`;

export const IconWrapper = styled.button`
  position: absolute;
  top: 110px;
  background: none;
  border: 0;
  outline: 0;

  svg {
    cursor: pointer;
  }
`;
